import Card from "./Card";
import Image from "./Image";

function SideNav() {
  const sideNavContent =
    "https://res.cloudinary.com/nuirai/image/upload/v1647713325/passage/side-nav_ur1dvj.png";
  return (
    <div
      className="side-nav w-[12.5%] h-full"
      style={{ transformStyle: "preserve-3d" }}
    >
      <Card
        borderRadius="rounded-bl-3xl"
        innerContent={<Image src={sideNavContent} />}
      ></Card>
    </div>
  );
}

export default SideNav;
